import React, { useContext } from 'react';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

const getExpansionsSummary = (i18n, finalUrlExpansions) => {
  const exactUrls = [];
  const rules = [];

  _.each(finalUrlExpansions, (target) => {
    const conditions = target.Criterion.WebPage.Parameter.Conditions;
    _.each(conditions, (condition) => {
      if (condition.Operator === 'Equals') {
        exactUrls.push(condition.ArgumentOperand);
      } else {
        rules.push(`URL contains ${condition.ArgumentOperand}`);
      }
    });
  });

  const exactUrlsDetails = exactUrls.length > 0 ? `${i18n.getString(_TL_('Excluded URLs: '))}${exactUrls.join(', ')}` : null;
  const rulesDetails = rules.length > 0 ? `${i18n.getString(_TL_('Exclusion rules: '))}${rules.join(', ')}`:null;

  if (exactUrlsDetails && rulesDetails) {
    return `${exactUrlsDetails}; ${rulesDetails}`;
  }
  return exactUrlsDetails || rulesDetails || i18n.getString(_TL_('You’ve disabled Final URL expansion'));
};

export const FinalURLExpansions = ({ data }) => {
  const i18n = useContext(I18nContext);
  const { finalUrlExpansions } = data || {};

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Final URL Expansions') }}>
      <Text>{getExpansionsSummary(i18n, finalUrlExpansions)}</Text>
    </PropertyRow>
  );
};

FinalURLExpansions.propTypes = {
  data: PropTypes.shape({
    finalUrlExpansions: PropTypes.arrayOf(PropTypes.string),
  }),
};

FinalURLExpansions.defaultProps = {
  data: {},
};
